import './LinkLibraryActionsMenu.scss';

import React, { FunctionComponent, useRef, useState } from 'react';

import { DonationLink } from '../../../types/__generated-graphQL__';
import { useDonationLinkContext } from '../../context/donationLinkContext';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { useTranslation } from 'react-i18next';

const Menu: FunctionComponent<{
  clickOutsideHandler: (arg: boolean) => void;
  donationLink: DonationLink;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
}> = ({ clickOutsideHandler, donationLink, buttonRef }) => {
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => clickOutsideHandler(false), buttonRef);
  const { dispatch } = useDonationLinkContext();
  const { t } = useTranslation();

  if (donationLink.isArchived) {
    return (
      <div className="actions__menu" ref={ref}>
        <ul className="actions__menu__items">
          <li className="actions__menu__item">
            <button
              className="actions__menu__button"
              onClick={() => {
                dispatch({ type: 'openViewModal', donationLink });
                clickOutsideHandler(false);
              }}
            >
              {t('linkLibrary.donationLinks.viewDetails')}
            </button>
          </li>
          <li className="actions__menu__item">
            <button
              className="actions__menu__button"
              onClick={() => {
                dispatch({ type: 'openRestoreModal', donationLink });
                clickOutsideHandler(false);
              }}
            >
              {t('linkLibrary.donationLinks.restore')}
            </button>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <div className="actions__menu" ref={ref}>
      <ul className="actions__menu__items">
        <li className="actions__menu__item">
          <button
            className="actions__menu__button"
            onClick={() => {
              dispatch({ type: 'openShareModal', donationLink });
              clickOutsideHandler(false);
            }}
          >
            {t('linkLibrary.donationLinks.share')}
          </button>
        </li>
        {!donationLink.isDefault && (
          <>
            <li className="actions__menu__item">
              <button
                className="actions__menu__button"
                onClick={() => {
                  dispatch({ type: 'openViewModal', donationLink });
                  clickOutsideHandler(false);
                }}
              >
                {t('linkLibrary.donationLinks.editViewDetails')}
              </button>
            </li>
            <li className="actions__menu__item">
              <button
                className="actions__menu__button"
                onClick={() => {
                  dispatch({ type: 'openArchiveModal', donationLink });
                  clickOutsideHandler(false);
                }}
              >
                {t('linkLibrary.donationLinks.archive')}
              </button>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

const LinkLibraryActionsMenu: FunctionComponent<{
  donationLink: DonationLink;
}> = ({ donationLink }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const actionsButtonRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();

  return (
    <div className="actions">
      <button
        ref={actionsButtonRef}
        className="actions__button"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-haspopup="true"
        aria-expanded={isMenuOpen}
      >
        {t('linkLibrary.donationLinks.actions')}
      </button>
      {isMenuOpen && (
        <Menu
          clickOutsideHandler={setIsMenuOpen}
          donationLink={donationLink}
          buttonRef={actionsButtonRef}
        />
      )}
    </div>
  );
};

export default LinkLibraryActionsMenu;
